export const PAHT_BY_LEVEL = {
    超初級: "/class/level/super-beginner.html",
    初級: "/class/level/beginner.html",
    初中級: "/class/level/middle-beginner.html",
    中級: "/class/level/middle.html",
};
